<div>
    <app-header *ngIf="!hideHeaderFooter" class="appheader"></app-header>
<app-layout></app-layout>
</div>
<app-footer *ngIf="!hideHeaderFooter" class="appfooter"></app-footer>
